// extracted by mini-css-extract-plugin
module.exports = {"searchSidebar":"styles__searchSidebar___3RrA1"};